import { useState } from 'react'
import { Fingerprint, Loader2 } from 'lucide-react'

interface AppLockScreenProps {
  onUnlock: () => Promise<boolean>
}

/**
 * 앱 잠금 화면 — 생체인증(지문/얼굴)으로 해제
 */
export function AppLockScreen({ onUnlock }: AppLockScreenProps) {
  const [isAuthenticating, setIsAuthenticating] = useState(false)
  const [error, setError] = useState(false)

  const handleUnlock = async () => {
    setIsAuthenticating(true)
    setError(false)
    const success = await onUnlock()
    setIsAuthenticating(false)
    if (!success) setError(true)
  }

  return (
    <div className="fixed inset-0 z-[200] bg-surface-primary flex flex-col items-center justify-center">
      <div className="w-16 h-16 rounded-2xl bg-primary-50 dark:bg-primary-900/20 flex items-center justify-center mb-6">
        <Fingerprint className="w-8 h-8 text-primary-500" />
      </div>

      <h2 className="text-lg font-semibold text-heading mb-2">앱 잠김</h2>
      <p className="text-sm text-caption mb-8">생체인증으로 잠금을 해제하세요</p>

      <button
        onClick={handleUnlock}
        disabled={isAuthenticating}
        className="flex items-center gap-2 px-6 py-3 bg-primary-500 text-white rounded-xl hover:bg-primary-600 disabled:opacity-50 transition-colors"
      >
        {isAuthenticating ? (
          <Loader2 className="w-5 h-5 animate-spin" />
        ) : (
          <Fingerprint className="w-5 h-5" />
        )}
        {isAuthenticating ? '인증 중...' : '잠금 해제'}
      </button>

      {error && (
        <p className="text-sm text-red-500 mt-4">인증에 실패했습니다. 다시 시도해주세요.</p>
      )}
    </div>
  )
}
